/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import { Button, Conditional, Text, Space } from '@cashfree-intl/coherent';

import { useQuery, isICICIDashboard, isLKDashboard } from 'utils/common';
import { TEST } from 'utils/constants';

import { PITCH_PAGE_DESCRIPTION } from '../constants';

import primarybg from '../../../images/pitch-banner-bg.png';
import lendingkartbg from '../../../images/lendingkart-pitch-banner-bg.png';
import icicibg from '../../../images/icici-pitch-banner-bg.png';
// will be used for idfc
import easysplit from '../../../images/easy-split.svg';
import easysplitthumbanil from '../../../images/easy-split-thumbnail.png';
import youtubeIcon from '../../../images/youtube.svg';
// import odsettlementsidfcbg from '../../../images/idfc-pitch-banner-bg.png';

const renderDescription = () =>
  PITCH_PAGE_DESCRIPTION.map(obj => (
    <div className="description-item" key={obj.title}>
      <div className="large-text text-dark w-600 title">{obj.title}</div>
      <div className="line" />
      <div className="content text-light">{obj.content}</div>
    </div>
  ));

function PitchPage({ onTryTest, playVideo }) {
  const query = useQuery();
  const isTestEnv = query.get('env') === TEST;

  const computeAssets = () => {
    if (isICICIDashboard()) {
      return icicibg;
    }
    if (isLKDashboard()) {
      return lendingkartbg;
    }
    return primarybg;
  };

  const backgroundImage = computeAssets();

  const styleProps = {
    backgroundImage: `url(${backgroundImage})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  };

  return (
    <div className="easy-split-pitch-page pitch-page-container">
      <Space
        justifyContent="space-between"
        alignItems="flex-start"
        className="easy-split-banner"
        style={styleProps}
      >
        <div>
          <Space alignItems="center" gap={2}>
            <img src={easysplit} alt="Easy Split icon" />
            <Text variant="h28" color="white">
              Easy Split
            </Text>
          </Space>
          <Text variant="h16" color="white" className="mt-4 mb-4 pitch-text">
            Automate payment splits to multiple accounts, vendors, and partners,
            with Easy Split. <br />
            <br />
            Collect customer payments, specify payment split details, settle
            payments to vendor accounts with flexible settlement plans, and
            easily manage any refunds/adjustments.
          </Text>
          {/* <Space alignItems="center" gap={2}> */}
          {/* Add loader later while integrating the api */}
          {/* <Button type="button" default onClick={requestActivation}>
              <span className="text-primary">Request Activation</span>
            </Button> */}
          <Conditional if={!isTestEnv}>
            <Button
              type="button"
              default
              onClick={onTryTest}
              data-event-name="Primary_Button_TryTestEnvironment"
            >
              <span className="text-primary">Try Test Environment</span>
            </Button>
          </Conditional>
          <Text color="white" className="mt-2">
            Raise request through account manager for Easy Split activation or
            email <span className="w-600">care@cashfree.com</span> with subject
            line &quot;
            <span className="w-600">Request to activate Easy Split</span>&quot;
          </Text>
          {/* </Space> */}
        </div>
        <div className="thumbnail-wrapper" onClick={playVideo}>
          <img src={easysplitthumbanil} alt="Easy Split thumbnail" />
          <img src={youtubeIcon} alt="youtube icon" className="youtube-icon" />
        </div>
      </Space>
      <div className="pitch-page-description">
        <div className="big-text text-dark w-600">
          How does Easy Split work?
        </div>
        <div className="description-items-wrapper">{renderDescription()}</div>
      </div>
    </div>
  );
}

PitchPage.propTypes = {
  // requestActivation: PropTypes.func.isRequired,
  onTryTest: PropTypes.func.isRequired,
  playVideo: PropTypes.func.isRequired,
};

export default PitchPage;
